export default __webpack_public_path__ + "static/media/cabinet1-before-2048w.1a60ed4a.webp";